const INDUSTRIES = [
  { icon: 'ri-hospital-line', en: 'Hospitals & Clinics', ar: 'المستشفيات والعيادات' },
  { icon: 'ri-restaurant-2-line', en: 'Food & Beverage', ar: 'الأغذية والمشروبات' },
  { icon: 'ri-flask-line', en: 'Laboratories', ar: 'المختبرات' },
  { icon: 'ri-building-2-line', en: 'Factories & Industry', ar: 'المصانع والصناعة' },
  { icon: 'ri-hotel-line', en: 'Hotels & Hospitality', ar: 'الفنادق والضيافة' },
  { icon: 'ri-government-line', en: 'Government & Military', ar: 'الحكومة والجيش' },
  { icon: 'ri-medicine-bottle-line', en: 'Pharmacies & Clinics', ar: 'الصيدليات والعيادات' },
  { icon: 'ri-recycle-line', en: 'Waste & Sanitation', ar: 'النفايات والصرف الصحي' },
];

export default function Industries() {
  return (
    <section className="section-padding bg-gray-50">
      <div className="container-max">
        <div className="text-center mb-12">
          <span className="trust-badge mb-4 inline-flex">🏆 8 Key Sectors — Trusted Across Industries</span>
          <h2 className="section-title-en text-3xl md:text-4xl mb-2">
            8 Industries That Trust Us
          </h2>
          <p className="section-title-ar text-2xl md:text-3xl" dir="rtl">
            8 قطاعات تثق بنا
          </p>
          <p className="text-gray-600 text-sm mt-3 max-w-xl mx-auto">
            From operating theatres to factory floors — omandisposables.com has been the glove of choice across every sector in Oman and the GCC.
          </p>
          <p className="font-arabic text-gray-600 text-sm mt-1 max-w-xl mx-auto" dir="rtl">
            من غرف العمليات إلى أرضيات المصانع — omandisposables.com هو الخيار الأول في كل قطاع في عُمان والخليج.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-5">
          {INDUSTRIES.map((item, i) => (
            <div
              key={i}
              className="relative flex flex-col items-center text-center p-6 bg-white rounded-2xl border-2 border-gray-100 hover:border-brand-green/50 transition-all group overflow-hidden"
            >
              {/* Segment number */}
              <span className="absolute top-3 right-3 text-[10px] font-bold text-gray-500 font-heading">
                {String(i + 1).padStart(2, '0')}
              </span>
              <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-navy/5 mb-4 group-hover:bg-brand-green/10 transition-colors">
                <i className={`${item.icon} text-3xl text-navy group-hover:text-brand-green transition-colors`} />
              </div>
              <p className="font-heading font-bold text-navy text-sm leading-snug">{item.en}</p>
              <p className="font-arabic text-gray-600 text-xs mt-1 leading-relaxed" dir="rtl">{item.ar}</p>
              {/* Bottom accent line */}
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-brand-green scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
            </div>
          ))}
        </div>

        {/* Bottom trust line */}
        <div className="mt-10 text-center">
          <p className="text-gray-600 text-sm">
            Supplying <strong className="text-navy">500+ clients</strong> across all 8 sectors in Oman and the GCC
          </p>
          <p className="font-arabic text-gray-600 text-sm mt-1" dir="rtl">
            نخدم أكثر من 500 عميل في جميع القطاعات الـ 8 في عُمان ودول الخليج
          </p>
        </div>
      </div>
    </section>
  );
}
